const getInitials = (str) => {
  if (!str) return "";
  const splittedName = str.split(" ");
  if (splittedName.length === 1) {
    return str.charAt(0).toUpperCase();
  } else if (splittedName.length === 2) {
    return (
      splittedName[0].charAt(0).toUpperCase() +
      splittedName[1].charAt(0).toUpperCase
    );
  } else {
    return (
      splittedName[0].charAt(0).toUpperCase() +
      splittedName[splittedName.length - 1].charAt(0).toUpperCase()
    );
  }
};

export default getInitials;
